(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socka-bundles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('.socka-bundles__form button[type="submit"]');
  const form = trigger?.closest('.socka-bundles__form');
  if (!form) return;
  event.preventDefault();
  if (!form.reportValidity()) return;
  const section = form.closest('.socka-bundles');
  const strings = section.querySelector('.socka-bundles__strings').dataset;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[role="status"]');
  button.disabled = true;
  status.textContent = strings.working;
  const pack = form.dataset.pack === '1' ? strings.grip : form.dataset.pack === '2' ? strings.kit : strings.five;
  const items = [...form.querySelectorAll('select')].map(select => ({id: Number(select.value), quantity: 1, properties: {'Bundle selection': pack}}));
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || strings.error);
    window.location.assign(root + 'cart');
  } catch(error) {
    status.textContent = error.message || strings.error;
    button.disabled = false;
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
